import Button from 'components/form-elements/buttons/Button'
import Input from 'components/form-elements/input/Input'
import ReactSelect from 'components/form-elements/select/ReactSelect'
import { useEffect, useRef, useState } from 'react'
// import { BsSearch } from 'react-icons/bs'
import { GrClose } from 'react-icons/gr'
import { useDispatch, useSelector } from 'react-redux'
import {  updateUserChoises, useEffectTrigger } from 'redux/features/general/generalSlice'
import CountryList from 'country-list-with-dial-code-and-flag'
import CountryFlagSvg from 'country-list-with-dial-code-and-flag/dist/flag-svg'
import { useRequest } from 'hooks/useRequest'
import { toast } from 'react-toastify'
import { stages } from 'utils/Constants'
import LoaderTwo from 'pages/LoaderTwo'
import Loader from 'pages/Loader'
import useTranslate from 'hooks/useTranslate'
import { dataLayerPush } from 'utils/Datalayer'

const AddressAddDrawer = ({forHome, setRegisterState, setIsOpenDrawer, setAddressInfo, addressInfo, isOpenDrawer }) => {
  const dispatch = useDispatch()
  const [request,loading] = useRequest();
  const { currentLocation, updateAddress } = useSelector(state => state.general)
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [neighbourhoods, setNeighbourhoods] = useState([]);
  const [isStreetFocus, setIsStreetFocus] = useState(false)
  const streetWrapperRef = useRef(null)
  const { t } = useTranslate()
  //const [streets, setStreets] = useState([]);
  //const [buildings, setBuildings] = useState([]);
  const [streetResults, setStreetResults] = useState([]);
  const [timer, setTimer] = useState(null)

  const countries = [
    ...CountryList.getAll().map(ct => ({ label: ct.data.dial_code, value: ct.data.dial_code, image: CountryFlagSvg[ct.data.code] }))
  ];


  useEffect(() => {
   if (isOpenDrawer && !addressInfo.firstName ) {
    request('/Profile', {
      method: 'GET',
    }).then(res => {
      if (res.data.ok) {
        const profileInfo = res.data.result
        const defaultCountry = countries.find(ct => ct.value == '+' + profileInfo?.countryCode?.toString())
        setAddressInfo(prev => ({
          ...prev,
          firstName: profileInfo?.firstName,
          lastName: profileInfo?.lastName,
          phone:profileInfo?.phone,
          countryCode:defaultCountry
        }))
      }
    })
   }
  },[isOpenDrawer])
  
  useEffect(() => {

    if (updateAddress) {
      setAddressInfo(prev => ({
        ...prev,
        ...updateAddress,
        countryCode:countries.find(ct => ct.value.slice(1) == updateAddress.countryCode),
      }))
    }
  }, [updateAddress])
  useEffect(() => {
    if (currentLocation) {
      setAddressInfo(prev => ({
        ...prev,
        ...currentLocation
      }))
    }
  }, [currentLocation])
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (streetWrapperRef.current && !streetWrapperRef.current.contains(event.target)) {
          setIsStreetFocus(false)
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [streetWrapperRef]);
  useEffect(() => {
    request('/Location/Provinces', {
      method: 'GET',
    }).then((res) => {
      if (res) {
        setProvinces(res?.data?.result?.map(province => ({ value: province.name, label: province.name, id: province.provinceId })))
        if (addressInfo?.provinceId) {
          request(`/Location/Districts/${addressInfo?.provinceId}`, {
            method: "GET"
          })
            .then((res) => {
              setDistricts(res?.data?.result?.map(district => ({ value: district.name, label: district.name, id: district.districtId })))
              if (addressInfo?.districtId) {
                request(`/Location/Neighbourhoods/${addressInfo?.districtId}`, {
                  method: "GET"
                })
                  .then((res) => {
                    setNeighbourhoods(res?.data?.result?.map(neighbourhood => ({ value: neighbourhood.name, label: neighbourhood.name, id: neighbourhood.neighbourhoodId, districtId: neighbourhood.districtId, latY: neighbourhood.latY, longX: neighbourhood.longX })))
                  })
              }
            })
        }

      }
    })
  }, [addressInfo?.provinceId, addressInfo?.districtId, addressInfo?.neighbourhoodId])

  const handleChange = (e, name, id) => {
    if (name && id) {
      setAddressInfo({ ...addressInfo, [name]: e?.value, [id]: e?.id,latitude:undefined, longitude:undefined,streetId: undefined, street:'' })
    } else if (name) {
      setAddressInfo({ ...addressInfo, [name]: e?.value })
    } else {
      setAddressInfo({ ...addressInfo, [e.target.name]: e?.target.value })
    }
  }
  const addAdress = () => {

    let sendAddressInfo = Object.keys(addressInfo)
      .filter((a) => !a.includes("undefined"))
      .reduce((obj, key) => {
        obj[key] = addressInfo[key]
        return obj
      }, {})
    setTimeout(() => {
      request('Profile/UpsertAddress', {
        method: "POST",
        data: {...sendAddressInfo, countryCode: addressInfo.countryCode.value.slice(1)}
      })
        .then(res => {
          if (res && res.data.ok) {
            dataLayerPush({ ecommerce: null });
            dataLayerPush({
              event:"add_shipping_info",
              ecommerce: {
              item_list_name: "Listeleme Sayfası",
              shipping_tier: "Adrese Teslim" ,
              delivery_type: "Temassız Teslimat",   
              }
            })
            if (!sendAddressInfo.id) {
              toast.success(t('successfullToast',{name:t('address'),type:t('add')}))
              setRegisterState && setRegisterState(stages.STAGE_BRANCH)
              
              setRegisterState && dispatch(updateUserChoises({addressId : res?.data?.result?.id, text: "Adres", neighbourhoodId: addressInfo?.neighbourhoodId}))
              forHome && dispatch(updateUserChoises({addressId : res?.data?.result?.id, text: "Adres", neighbourhoodId: addressInfo?.neighbourhoodId}))
              //forHome && dispatch(homeAddressReChoice({openStatus: true, step: 2}))
            } else {
              toast.success(t('successfullToast',{name:t('address'),type:t('update')}))
            }
            //setAddressInfo({})
            dispatch(useEffectTrigger(Math.floor(Math.random() * 1000)))
            //dispatch(updateAddressFunc())
            //dispatch(currentLocationFunc())
            setIsOpenDrawer(false)
          }
        })
    }, 300);
  }

  const handleStreetChange = (e) => { 
    let val = e.target.value; 

    setAddressInfo(prev => ({
      ...prev,
      latitude: undefined,
      longitude: undefined,
      streetId:undefined,
      street: val
    }))

    clearTimeout(timer)

    const newTimer = setTimeout(() => {
      if (addressInfo?.neighbourhoodId && val.length >= 3 ) {
        request(`/Location/SearchAddress`, {
        method: "POST",
        data: {
          search : val,
          province: addressInfo?.province,
          district: addressInfo?.district,
          neighbourhood: addressInfo?.neighbourhood
        }
   })
   .then((res) => {
    if(res){
      setStreetResults(res?.data?.result)
    }
   })
} else if (addressInfo?.neighbourhoodId && val.length < 3) {
  setStreetResults([])
}
    }, 1000)

    setTimer(newTimer)

    
  }

  const autoCompleteChoice = (street) => {
    setAddressInfo(prev => ({
      ...prev,
      ...street,
      neighbourhood: prev.neighbourhood,
      street: street?.address
    }))
    setStreetResults([])
    setIsStreetFocus(false)
  }

  useEffect(() => {

    if (!addressInfo.countryCode) {
      const defaultCountry = countries.find(ct => ct.value == "+90")
      setAddressInfo({ ...addressInfo, countryCode: defaultCountry })
    }

  }, [addressInfo.countryCode])

  return (
    <>
      <div className='addressAddDrawer'>
        <LoaderTwo isDataLoading={loading} />
        <div onClick={() => setIsOpenDrawer(false)} className='addressAddDrawer-close'>
          <GrClose size={30} />
        </div>
        <div className='addressAddDrawer-title'>{t('addAddress')}</div>
        {/* <Button className='btn-primary-outline btn-pinmap' onClick={() => dispatch(setPinMapModal({ open: true }))} icon={images.pinMap} text='Haritadan Ekle' /> */}
        <div className='register-container-flexInput'>
          <Input
            value={addressInfo?.firstName ? addressInfo?.firstName : ""}
            onChange={handleChange}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelName')}
            type={'text'}
            textLabel={t('labelName')}
            name={"firstName"}
            required
          />
          <Input
            value={addressInfo?.lastName ? addressInfo?.lastName : ""}
            onChange={handleChange}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelSurame')}
            type={'text'}
            textLabel={t('labelSurame')}
            name={"lastName"}
            required
          />
        </div>
        <div className='register-container-flexInput'>
          <ReactSelect
             handleChange={(d) => handleChange({ target: { name: 'countryCode', value: d } })} 
            //value={addressInfo?.countryCode}
            //defaultValue={[{ value: addressInfo?.countryCode, label: addressInfo?.countryCode, image: "" }]} 
            value={addressInfo?.countryCode}
            labelText={t('labelCountry')}
            className={"countrySelect"}
            placeholder={t('choosePlaceholder')}
            options={countries}
            name={"countryCode"}
            isSearchable
          //id={"countryCode"}
          />
          <Input
            value={addressInfo?.phone ? addressInfo?.phone : ""}
            onChange={handleChange}
            name={"phone"}
            containerClassName={"inputPhoneClassNameContainer"}
            className={''} labelClassName={'stageTwoLabel'}
            placeholder={t('labelPhone')}
            maxLength={10}
            required
            type={'number'}
            textLabel={t('labelPhone')} />
        </div>
        <hr />
        <div className='addressAddDrawer-fullWidth mt-4'>
          <ReactSelect
          required
            labelText={t('labelProvince')}
            handleChange={e => handleChange(e, "province", "provinceId")}
            value={addressInfo?.provinceId ? { value: addressInfo?.province, label: addressInfo?.province, id: addressInfo?.provinceId }: ""}
            name={"province"}
            className={"countrySelect"}
            placeholder={t('choosePlaceholder')}
            options={provinces}
            isSearchable
          />
          {/* <label htmlFor="search">Mahalle</label>
        <div className='addressAddDrawer-search-sub'>
          <BsSearch />
          <input type="text" placeholder='Mahalle, sokak, cadde vb. arayın' />
        </div> */}
        </div>
        <div className='addressAddDrawer-fullWidth mt-4'>
          <ReactSelect
            labelText={t('labelDistrict')}
            className={"countrySelect"}
            placeholder={t('choosePlaceholder')}
            required
            handleChange={e => handleChange(e, "district", "districtId")}
            value={addressInfo?.districtId ? { value: addressInfo?.district, label: addressInfo?.district, id: addressInfo?.districtId } : ""}
            options={districts}
            isSearchable
          />
        </div>
        <div className='addressAddDrawer-fullWidth mt-4'>
          <ReactSelect
            handleChange={e => handleChange(e, "neighbourhood", "neighbourhoodId")}
            value={addressInfo?.neighbourhoodId ? { value: addressInfo?.neighbourhood, label: addressInfo?.neighbourhood, id: addressInfo.neighbourhoodId } : ""}
            options={neighbourhoods}
            required
            labelText={t('labelNeighbourhood')}
            className={"countrySelect"}
            placeholder={t('choosePlaceholder')}
            isSearchable
          />
        </div>
        <div ref={streetWrapperRef} className='addressAddDrawer-fullWidth mt-4 mb-4 addressAddDrawer-resultStreet'>
        <Input
            value={addressInfo?.street ? addressInfo?.street : ""}
            onChange={handleStreetChange}
            name={"street"}
            containerClassName={""}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelStreet')}
            type={'text'}
            required
            textLabel={t('labelStreet')}
            label={t('labelStreet')}
            onFocus={() => setIsStreetFocus(true)}
            />
            {
              isStreetFocus && <div className="addressAddDrawer-resultStreet-list" style={{top:75}}>
              {
                streetResults.length > 0 ? streetResults?.map((street,i) => (
                 <div key={i} onClick={() => autoCompleteChoice(street)} className="addressAddDrawer-resultStreet-list-item">
                     {street?.address}
                 </div>
               )) : <div className="addressAddDrawer-resultStreet-list-item">
                 {addressInfo?.street?.length > 2 && !loading ? t('resultNotFound') : loading && <Loader isDataLoading={loading} />}
                 {addressInfo?.street?.length < 3 && t('minimumCharacter')}
             </div>
              }
           </div>
            }
        </div>

        <div className='addressAddDrawer-fullWidth mt-4 mb-4'>
        <Input
            value={addressInfo?.building ? addressInfo?.building : ""}
            onChange={handleChange}
            name={"building"}
            containerClassName={""}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelBuildNo')}
            type={'text'}
            textLabel={t('labelBuildNo')}
            label={t('labelBuildNo')}
            />
        </div>
        {/* <div className='addressAddDrawer-search'>
        <label htmlFor="search">Sokak</label>
        <div className='addressAddDrawer-search-sub'>
          <BsSearch />
          <input type="text" placeholder='Mahalle, sokak, cadde vb. arayın' />
        </div>
      </div> */}
        {/* <Input containerClassName={""} className={''} labelClassName={'stageTwoLabel'} placeholder={"Label"} type={'text'} textLabel={'Bina'} /> */}
        <div className='register-container-flexInput'>
          <Input
            value={addressInfo?.floor ? addressInfo?.floor : ""}
            onChange={handleChange}
            name={"floor"}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelFloor')}
            type={'text'}
            textLabel={t('labelFloor')} />
          <Input
            value={addressInfo?.apartment ? addressInfo?.apartment : ""}
            onChange={handleChange}
            name={"apartment"}
            containerClassName={"w-half"}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelAparmentNo')}
            type={'text'}
            textLabel={t('labelAparmentNo')} />
        </div>
        <Input
          value={addressInfo?.addressDescription ? addressInfo?.addressDescription : ""}
          onChange={handleChange}
          name={"addressDescription"}
          containerClassName={""}
          className={''}
          labelClassName={'stageTwoLabel'}
          placeholder={t('labelForDirections')}
          type={'text'}
          textLabel={t('labelForDirections')} />
        <hr />
        <div className='addressAddDrawer-mt'>
          <Input
            value={addressInfo?.addressTitle ? addressInfo?.addressTitle : ""}
            onChange={handleChange}
            name={"addressTitle"}
            containerClassName={""}
            className={''}
            labelClassName={'stageTwoLabel'}
            placeholder={t('labelAddressName')}
            type={'text'}
            required
            textLabel={t('labelAddressName')} />
        </div>
        <Button onClick={addAdress} className={"claretredRoundedBtn"} icon={''} text={t('saveAddressBtn')} />
        <Button onClick={() => setIsOpenDrawer(false)} className={"grayRoundedBtn"} icon={''} text={t('cancel')} />
      </div>
    </>
  )
}

export default AddressAddDrawer